<template>
  <accordion title="Last minute bets" :classes="['bto-sb-widget-lastminute-bets']">
    <ul>
      <li>
        <span class="bto-sb-sports-icon soccer"></span>
        <span class="bto-sb-lastminute-item"><a href="#">Soccer</a></span>
        <span class="bto-sb-lastminute-matches">17</span>
      </li>
      <li>
        <span class="bto-sb-sports-icon basketball"></span>
        <span class="bto-sb-lastminute-item"><a href="#">Basketball</a></span>
        <span class="bto-sb-lastminute-matches">15</span>
      </li>
      <li>
        <span class="bto-sb-sports-icon ice-hockey"></span>
        <span class="bto-sb-lastminute-item"><a href="#">Ice Hockey</a></span>
        <span class="bto-sb-lastminute-matches">2</span>
      </li>
      <li>
        <span class="bto-sb-sports-icon golf"></span>
        <span class="bto-sb-lastminute-item"><a href="#">Golf</a></span>
        <span class="bto-sb-lastminute-matches">3</span>
      </li>
    </ul>
  </accordion>
</template>

<script>
  import Accordion from '../../shared/accordion';

  export default {
    name: 'LastMinuteBetsWidget',
    data() {
      return {
        expanded: true,
      };
    },
    methods: {
      toggleWidget() {
        this.expanded = !this.expanded;
      },
    },
    components: {
      Accordion
    }
  };
</script>
